import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/canteen/meal-restrictions')({
  staticData: {
    meta: {
      title: 'Ограничения в питании',
      description: '',
    },
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <Outlet />
}
